import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs, useRequestData } from 'wsm-common-data';
import MenuLink from './MenuLink';
import NavIcon from './NavIcon';
import NavFragment from './NavFragment';

const DropdownItem = ({
	enabled,
	grandChildItems,
	label,
	target,
	topMenuItemIndex,
	url
}) => {
	const { childListLinkClasses, mobileSubnavType } = usePrefs();
	const { deviceType } = useRequestData();

	if (!enabled) return <></>;

	const buildChildListLinkClasses = () => {
		const classesToReturn = [childListLinkClasses];
		if (deviceType === 'MOBILE') {
			if (grandChildItems.length) {
				classesToReturn.push(
					'panel-heading-link accordion-faux heading-tier2'
				);
			} else {
				classesToReturn.push('nav-link tier3');
			}
		}
		if (deviceType !== 'MOBILE') {
			classesToReturn.push('child');
		}

		return classesToReturn.join(' ').trim();
	};

	const classes = buildChildListLinkClasses();
	const additionalAttrs = { 'data-navigation-id': 'default' };
	const hasEmbeddedItems =
		deviceType === 'MOBILE' &&
		mobileSubnavType === 'full-screen' &&
		grandChildItems?.some((child) => child?.embedded);

	return (
		<>
			<MenuLink
				additionalAttrs={additionalAttrs}
				childListLinkClasses={classes}
				target={target}
				url={url}
			>
				<NavIcon label={label} />
			</MenuLink>
			{hasEmbeddedItems && (
				<li>
					<ul className="nav-fragment list-unstyled">
						{grandChildItems
							.filter((child) => child?.embedded)
							.map((child) => (
								<NavFragment
									key={child.id}
									fragmentId={child.id}
									fragmentUrl={child.url}
									topMenuItemIndex={topMenuItemIndex}
								/>
							))}
					</ul>
				</li>
			)}
		</>
	);
};

DropdownItem.propTypes = {
	grandChildItems: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			url: PropTypes.string,
			target: PropTypes.string
		})
	).isRequired,
	url: PropTypes.string.isRequired,
	target: PropTypes.string.isRequired,
	enabled: PropTypes.bool.isRequired,
	label: PropTypes.string.isRequired,
	topMenuItemIndex: PropTypes.number
};

export default DropdownItem;
